import logo from '../../Bot_Icons/logo.png';
import GDB from '../../Bot_Icons/GDB.png';
import D2Ch from'../../Bot_Icons/d2chests.png';
import LB9 from '../../Bot_Icons/LB9.png';
import '../../css/App.css';


function Homepage() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CmMLaFfdsCY?si=G55AY9A-kpjuBCnc" title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
        </iframe>

        <h1 >
        <a id = "bots" href= "http://travelerschosen.org/#/twitchbots">Travelers Chosen Team Bots</a>
        </h1>
      </header>
      
    </div>
  );
}

export default Homepage;
